module.exports = __webpack_public_path__ + "static/media/main_07.983a8767.png";